import React, { useCallback, useContext } from 'react'
import SectionFormContainer from '../../components/SectionFormContainer'
import GroomingProfileWizardContext from './GroomingProfileWizardContext'
import BreedPicker from './components/BreedPicker'
import BreedsContext from './BreedsContext'
import { DOODLE_COATS_CONFIG, GROOMING_PROFILE_KEYS } from './constants'
import { getAllowedGroomingServicesForPet } from './helpers'

const DoodleMix = (props) => {
	const {
		wizardContextProvider: { wizard_state, setWizardAttributeAndValues }
	} = useContext(GroomingProfileWizardContext)
	const {
		breedsContextProvider: { breeds }
	} = useContext(BreedsContext)
	const { attr, title = '', subtext = '' } = props

	const handleSelection = useCallback(
		(breed) => {
			const breedInfo = breeds[breed] || null
			const coat_type = breedInfo?.coat_type || ''

			const { coat_length, grooming_level } = DOODLE_COATS_CONFIG[coat_type] || {
				coat_length: '',
				grooming_level: ''
			}

			const newValues = { ...wizard_state }

			newValues[attr] = [breed, 'Poodle Mix']
			newValues[GROOMING_PROFILE_KEYS.coat_type] = coat_type
			newValues[GROOMING_PROFILE_KEYS.coat_length] = coat_length
			newValues[GROOMING_PROFILE_KEYS.grooming_level] = grooming_level

			const allowed_grooming_services = getAllowedGroomingServicesForPet(grooming_level)
			newValues[GROOMING_PROFILE_KEYS.allowed_grooming_services] = allowed_grooming_services

			setWizardAttributeAndValues(newValues)
		},
		[wizard_state, setWizardAttributeAndValues, attr, breeds]
	)

	return (
		<SectionFormContainer
			title={title}
			subtext={subtext}
			titleStyles={{ flex: 0, marginBottom: '1rem' }}
			childrenContainerStyles={{ flex: 0, marginBottom: '5rem' }}>
			<BreedPicker value={wizard_state[attr][0] || ''} onSelected={handleSelection} />
		</SectionFormContainer>
	)
}

export default DoodleMix
